var exports = {
  "i": "xaee3c4fa--a18d5d--wrapper",
};

module.exports = exports;
